import { render, staticRenderFns } from "./ActionTodoNoSwipe.vue?vue&type=template&id=c04a167e&"
import script from "./ActionTodoNoSwipe.vue?vue&type=script&lang=js&"
export * from "./ActionTodoNoSwipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports